// DailyLoginModal.js
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { RichCoinIcon } from '../assets/icons/Icons';
import { Icon } from '@iconify/react';

const ModalOverlay = styled.div`
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.85) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 999999 !important;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadeIn 0.2s ease-in-out !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContainer = styled.div`
  background-color: rgba(0, 0, 0, 0) !important; /* transparent background */
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow-y: auto !important;
  animation: slideIn 0.3s ease-in-out !important;
  z-index: 999999 !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  padding: 0 !important;
  
  @keyframes slideIn {
    from { transform: translateY(20px); opacity: 0.8; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 20px 5px;
  width: 100%;
  position: relative;
  
  @media (max-width: 360px) {
    padding: 16px 16px 5px;
  }
`;

const ModalTitle = styled.h2`
  font-size: 40px;
  color: white;
  text-align: left;
  font-weight: 600;
  margin: 0;
  padding: 0;
  line-height: 1.1;
  
  @media (max-width: 360px) {
    font-size: 34px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: 10px;
  margin-top: 2px;
  z-index: 100;
  opacity: 0.8;
  
  @media (max-width: 360px) {
    font-size: 34px;
    margin-left: 8px;
  }
`;

const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 20px;
  width: calc(100% - 40px);
  max-width: 500px;
  margin: 10px auto 20px auto; /* Added margin-top to create some space after the header */
`;

const DayCard = styled.div`
  background-color: ${props => props.$active ? 'rgba(255, 255, 255, 0.1)' : '#2A2A2A'};
  border: ${props => props.$active ? '2px solid #7289DA' : '2px solid transparent'};
  border-radius: 16px;
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  transition: all 0.2s ease;
  
  &:active {
    transform: ${props => props.$active ? 'scale(0.97)' : 'none'};
  }
  
  @media (max-width: 360px) {
    padding: 10px 8px;
  }
`;

const DayNumber = styled.div`
  font-size: 15px;
  color: white;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
  
  @media (max-width: 360px) {
    font-size: 14px;
  }
`;

const RewardAmount = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: white;
  display: flex;
  align-items: center;
  gap: 5px;
  
  @media (max-width: 360px) {
    font-size: 22px;
  }
`;

const LastDayCard = styled(DayCard)`
  grid-column: 1 / span 2;
  background-color: ${props => props.$active ? 'rgba(255, 255, 255, 0.1)' : 'rgba(60, 60, 60, 0.5)'};
  border: ${props => props.$active ? '2px solid #FFC400' : '2px solid transparent'};
  padding: 16px 10px;
  
  ${RewardAmount} {
    font-size: 30px;
  }
  
  @media (max-width: 360px) {
    padding: 12px 10px;
  }
`;

const CoinContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1px;
  transform: translateY(-0.5px); /* Slight adjustment for better vertical alignment */
`;

const CheckMarkIcon = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #7289DA;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
  
  svg {
    width: 15px;
    height: 15px;
  }
  
  @media (max-width: 360px) {
    width: 20px;
    height: 20px;
    
    svg {
      width: 13px;
      height: 13px;
    }
  }
`;

const ClaimButton = styled.button`
  background-color: ${props => props.$active ? '#7C7C7C' : '#6E6E6E'};
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 500;
  padding: 14px;
  width: calc(100% - 40px);
  max-width: 500px;
  margin: 10px auto;
  cursor: ${props => props.$active ? 'pointer' : 'not-allowed'};
  transition: all 0.2s ease;
  display: block;
  position: relative;
  
  &:active {
    transform: ${props => props.$active ? 'scale(0.98)' : 'none'};
    background-color: ${props => props.$active ? '#8C8C8C' : '#6E6E6E'};
  }
  
  &:hover {
    background-color: ${props => props.$active ? '#8C8C8C' : '#6E6E6E'};
  }
  
  @media (max-width: 360px) {
    padding: 12px;
    font-size: 16px;
  }
`;

const DailyLoginModal = ({ isOpen, onClose }) => {
  const [currentDay] = React.useState(1); // Assume the user is on day 1
  const dailyRewards = [
    { day: 1, amount: 100, claimed: true },
    { day: 2, amount: 200, claimed: false },
    { day: 3, amount: 300, claimed: false },
    { day: 4, amount: 400, claimed: false },
    { day: 5, amount: 500, claimed: false },
    { day: 6, amount: 600, claimed: false },
    { day: 7, amount: 10000, claimed: false }
  ];
  
  // Element to use for portal
  const portalRoot = document.getElementById('modal-root') || document.createElement('div');
    // Create portal root if it doesn't exist
  React.useEffect(() => {
    if (!document.getElementById('modal-root')) {
      portalRoot.id = 'modal-root';
      portalRoot.style.position = 'fixed';
      portalRoot.style.top = '0';
      portalRoot.style.left = '0';
      portalRoot.style.width = '100%';
      portalRoot.style.height = '100%';
      portalRoot.style.zIndex = '999999';
      document.body.appendChild(portalRoot);
    }
    
    return () => {
      // Clean up only if we created it
      if (portalRoot.parentElement && !isOpen) {
        document.body.removeChild(portalRoot);
      }
    };
  }, [isOpen, portalRoot]);
  // Add class to body when modal is open and ensure it's visible above everything
  React.useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
      
      // Force any fixed positioned elements to be hidden
      document.querySelectorAll('header, footer, nav, .HeaderWrapper, .CoinInfoContainer').forEach(elem => {
        if (elem) {
          elem.style.display = 'none';
        }
      });
      
      // Set extremely high z-index for the modal root
      const modalRoot = document.getElementById('modal-root');
      if (modalRoot) {
        modalRoot.style.zIndex = '2147483647'; // Max possible z-index
        modalRoot.style.position = 'fixed';
        modalRoot.style.top = '0';
        modalRoot.style.left = '0';
        modalRoot.style.width = '100vw';
        modalRoot.style.height = '100vh';
      }
      
      // Disable scrolling on the body
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    }
    
    return () => {
      document.body.classList.remove('modal-open');
      
      // Restore visibility
      document.querySelectorAll('header, footer, nav, .HeaderWrapper, .CoinInfoContainer').forEach(elem => {
        if (elem) {
          elem.style.display = '';
        }
      });
      
      // Re-enable scrolling
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const handleClaim = () => {
    // In a real app, this would make an API call to claim the reward
    alert("Reward claimed successfully!");
    onClose();
  };
  
  // Render using a portal
  return ReactDOM.createPortal(
    <ModalOverlay onClick={onClose} className="modal-overlay">      <ModalContainer onClick={e => e.stopPropagation()}>        <HeaderSection>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ModalTitle>Daily Login</ModalTitle>
            <CloseButton onClick={onClose}>×</CloseButton>
          </div>
        </HeaderSection>
        
        <DaysGrid>
          {dailyRewards.slice(0, 6).map((reward, index) => (
            <DayCard 
              key={index} 
              $active={reward.day === currentDay || reward.claimed}
            >
              <DayNumber>
                Day {reward.day}
                {reward.claimed && <CheckMarkIcon><Icon icon="lets-icons:check-fill" width="24" height="24" color="white" /></CheckMarkIcon>}
              </DayNumber>                <RewardAmount>
                +{reward.amount} 
                <CoinContainer>
                  <RichCoinIcon width="22" height="22" />
                </CoinContainer>
              </RewardAmount>
            </DayCard>
          ))}
          
          <LastDayCard $active={dailyRewards[6].day === currentDay}>
            <DayNumber>
              Day {dailyRewards[6].day}
              {dailyRewards[6].claimed && <CheckMarkIcon><Icon icon="lets-icons:check-fill" width="24" height="24" color="white" /></CheckMarkIcon>}
            </DayNumber>              <RewardAmount>
              +{dailyRewards[6].amount}
              <CoinContainer>
                <RichCoinIcon width="22" height="22" />
              </CoinContainer>
            </RewardAmount>
          </LastDayCard>
        </DaysGrid>
        
        <ClaimButton 
          $active={!dailyRewards[currentDay - 1].claimed}
          onClick={!dailyRewards[currentDay - 1].claimed ? handleClaim : null}
        >
          Claim reward        </ClaimButton>
      </ModalContainer>
    </ModalOverlay>,
    portalRoot
  );
};

export default DailyLoginModal;
